import { render, staticRenderFns } from "./CookieLaw.vue?vue&type=template&id=42ac9136"
import script from "./CookieLaw.vue?vue&type=script&lang=js"
export * from "./CookieLaw.vue?vue&type=script&lang=js"
import style0 from "./CookieLaw.vue?vue&type=style&index=0&id=42ac9136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports